import { CommonError } from "../types/common-error";

export function isCommonError(error: any): error is CommonError {
    const _err = error as CommonError;
    return _err?.message !== undefined &&
         _err?.details !== undefined
}